import { useIntl } from 'react-intl';
import { Table } from '../../../../ui';
import { ColumnsType } from 'antd/es/table';
import { ListingProduct } from '../types';
import { Tooltip } from 'antd';
import { FallbackImage } from 'ui/UploadImage/fallBack/FallBackImage';
import { findQualityMark } from 'utils/qualityMarkHelpers';
import { QualityMarkId } from 'types/ListingData';

interface QualityMarkData {
  id: QualityMarkId;
  name: string;
  logo?: string;
}

interface ProductsTabProps {
  products: ListingProduct[];
  allQualityMarks?: QualityMarkData[];
}

export const ProductsTab = ({
  products,
  allQualityMarks,
}: ProductsTabProps) => {
  const intl = useIntl();

  const columns: ColumnsType<ListingProduct> = [
    {
      title: intl.formatMessage({ id: 'listing.product_category' }),
      key: 'category',
      render: (_text, record) => {
        const name = record.name || record.category?.name || '-';
        const marks = (record.quality_mark_ids || [])
          .map((id) => findQualityMark(allQualityMarks, id))
          .filter((qm): qm is QualityMarkData => !!qm);

        return (
          <div className="product-name-with-marks">
            <span>{name}</span>
            {marks.length > 0 && (
              <div className="quality-marks-cell">
                {marks.map((qmark) => (
                  <Tooltip key={qmark.id} title={qmark.name}>
                    <span>
                      <FallbackImage
                        className="quality-mark"
                        src={qmark.logo || ''}
                        type="notFound"
                        preview={false}
                      />
                    </span>
                  </Tooltip>
                ))}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: intl.formatMessage({ id: 'listing.quantity_and_unit' }),
      key: 'quantity',
      render: (_text, record) => {
        const quantity = record.required_quantity;
        const unit =
          record.storage_unit?.short || record.storage_unit?.name || '';
        return `${quantity} ${unit}`;
      },
    },
    {
      title: intl.formatMessage({
        id: 'listings.min_acceptable_offer_quantity',
      }),
      key: 'min_quantity',
      render: (_text, record) => {
        if (!record.min_acceptable_offer_quantity) return '-';
        const unit =
          record.storage_unit?.short || record.storage_unit?.name || '';
        return `${record.min_acceptable_offer_quantity} ${unit}`;
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={products}
      disablePagination={true}
      rowKey="id"
    />
  );
};
